module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/awesome-typescript-loader/dist/entry.js!./login.ts"));
	}, "members-async-login");
}